import type { ButtonHTMLAttributes } from 'react';
import { cx } from './format';
import s from './ui.module.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'danger' | 'dangerSolid' | 'ghost';
  size?: 'md' | 'sm';
  busy?: boolean;
}

export function Button({ variant = 'default', size = 'md', busy = false, className, disabled, children, type = 'button', ...rest }: ButtonProps) {
  return (
    <button
      type={type}
      className={cx(s.btn, size === 'sm' && s.sm, variant !== 'default' && s[variant], className)}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      {...rest}
    >
      {busy && <span className={s.spinner} aria-hidden />}
      {children}
    </button>
  );
}
